class Monitoring.Methods.WrappedRequest

  constructor: (@url, @params) ->
    # nothing to do

  execute: (options) ->
    method = options.method
    target = options.target || '_self'
    if method == 'post'
      @executePost(target)
    else if method == 'delete'
      @executeDelete(target)
    else
      @executeGet(target)
    true

  executePost: (target) ->
    form = document.createElement('form')
    form.action = @url
    form.method = 'POST'
    form.target = target
    for key, value of @params
      field = document.createElement('input')
      field.setAttribute('type', 'hidden')
      field.name = key
      field.value = value
      form.appendChild(field)
    form.style.display = 'none'
    document.body.appendChild(form)
    form.submit()

  executeDelete: (target) ->
    link = document.createElement('a')
    link.setAttribute('data-method', 'DELETE')
    link.href = @url
    document.body.appendChild(link)
    link.click()

  executeGet: (target) ->
    win = window.open("#{@url}?" + $.param(@params), target)
    win.focus()
